import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  requestNo: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export function TransferReviseConfirmDialog({
  open,
  requestNo,
  loading,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !loading && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ບັນທຶກຈຳນວນອະນຸມັດ</DialogTitle>
          <DialogDescription>
            {requestNo} — ຢືນຢັນອັບເດດຈຳນວນອະນຸມັດກ່ອນຈັດສົ່ງ
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            ກັບຄືນ
          </Button>
          <Button isLoading={loading} onClick={() => void onConfirm()}>
            ຢືນຢັນບັນທຶກ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
